import React from 'react';
import { s, SPEC_COLORS } from '../styles';
import { SignalSection } from '../atoms';
import { IconSqueeze, IconWind, IconRelax, IconPush, IconPelvis, IconSpark } from '../icons';

// Screen 12 — Correct vs incorrect signals recap. Two SignalSections:
// the squeeze recap (rose accent) and the relax recap (mauve accent).
// Closes out the lesson before finishAndContinue dismisses the overlay.
export function Content({ t }) {
  return (
    <div className="screen-enter">
      <h1 style={s.title} className="screen-enter-child">{t('fl_correct_title')}</h1>
      <div className="screen-enter-child">
        <SignalSection
          label={t('fl_correct_squeeze_label')}
          accent={SPEC_COLORS.squeeze}
          bullets={[
            t('fl_correct_squeeze_bullet_1'),
            t('fl_correct_squeeze_bullet_2'),
            t('fl_correct_squeeze_bullet_3'),
          ]}
          icons={[<IconSqueeze key="s1" />, <IconWind key="s2" />, <IconRelax key="s3" />]}
        />
      </div>
      <div className="screen-enter-child">
        <SignalSection
          label={t('fl_correct_relax_label')}
          accent={SPEC_COLORS.relax}
          bullets={[
            t('fl_correct_relax_bullet_1'),
            t('fl_correct_relax_bullet_2'),
            t('fl_correct_relax_bullet_3'),
          ]}
          icons={[<IconPush key="r1" />, <IconPelvis key="r2" />, <IconSpark key="r3" />]}
        />
      </div>
    </div>
  );
}

export function Footer({ t, onFinish, saving }) {
  return (
    <button
      type="button"
      style={{ ...s.cta, ...(saving ? s.ctaDisabled : s.ctaEnabled) }}
      onClick={onFinish}
      disabled={saving}
    >
      {t('fl_correct_cta')}
    </button>
  );
}
